@if (showContent()) {
  <!-- Contenedor de la modal de guía de tallas -->
  <div class="content position-fixed start-0 top-0">
    <!-- Botón de cerrar modal -->
    <button
      type="button"
      class="close d-flex p-0 border-0 outline-none bg-transparent text-white fs-1 position-absolute top-0 end-0 m-2"
      aria-label="Close"
      (click)="onShowContentChange(false)"
    >
      <i class="inm-icon-close"></i>
    </button>

    <div class="message position-absolute top-0 start-0 m-2 text-white fw-bold">
      <span>{{ imageIndex() + 1 }}/{{ images()?.length }}</span>
    </div>

    <div class="content-carousel d-flex flex-column h-100 w-100 position-relative">
      <c-carousel
        [animate]="true"
        [interval]="0"
        [activeIndex]="imageIndex()"
        class="h-100 carousel-full-images"
        (itemChange)="onCurrentSlide($event)"
      >
        <c-carousel-indicators />

        <c-carousel-inner class="h-100">
          @for (img of images(); track img) {
            <c-carousel-item class="h-100">
              <div
                class="image d-flex justify-content-center rounded-2 overflow-hidden position-relative h-100"
              >
                <img
                  class="h-100 w-100 object-fit-contain"
                  [lazyLoad]="img | cdnUrl: 2000 : true"
                  alt="Imagen del producto"
                  loading="lazy"
                  (load)="onImageLoaded(false)"
                  (error)="onImageLoaded(false)"
                  appErrorImage
                />
              </div>
            </c-carousel-item>
          }
        </c-carousel-inner>

        @if (images().length > 1) {
          <c-carousel-control [routerLink] caption="Previous" direction="prev" />
          <c-carousel-control [routerLink] caption="Next" direction="next" />
        }
      </c-carousel>

      @if (isLoading()) {
        <div
          class="spinner d-flex align-items-center justify-content-center position-absolute start-50 top-50"
        >
          <mat-spinner class="card-spinner" [diameter]="50"></mat-spinner>
        </div>
      }
    </div>
  </div>
}
